import React, { useEffect, useState, useContext, useRef } from 'react';
import { useHistory } from 'react-router';
import request from '../services/Request';
import 'react-simple-keyboard/build/css/index.css';
import KeyBoard from './items/keyboard';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CheckedBox } from '../Icons/checked.svg';
import { ReactComponent as UncheckedBox } from '../Icons/uncheck.svg';
export default function EnterEmail(props) {
  const {
    showProduct,
    error,
    setError,
    input,
    setInput,
    cart,
    langs,
    orderID,
    readySend,
    receipt,
    inputShow,
    receiptSend,
    separateItem,
    isCheck,
    isLocal,
    setCheck,
  } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const [show, setShow] = useState(props.show);

  const keyboard = useRef();

  const machine = JSON.parse(localStorage.getItem('machine'));

  const emailPattern = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$');

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
  };

  useEffect(() => {
    // console.log(props.cart);
    if (input === '') {
      setError('');
    } else if (emailPattern.test(input)) {
      setError('');
    } else {
      setError(t('Please enter valid email address.'));
    }
  }, [input]);

  useEffect(() => {
    if (props.show) {
      keyboard.current.focus();
    }
  }, [props.show]);

  useEffect(async () => {
    if (readySend && receiptSend) {
      const SENDEMAIL = '/receipt/send';
      const EMAILCODE = '/promos/emailCode';
      if (input !== '' && error === '') {
        console.log('separateItem?', separateItem);
        if (separateItem?.length > 0) {
          setTimeout(() => {
            request({
              method: 'post',
              url: SENDEMAIL,
              data: {
                orderID: orderID,
                email: input,
                receipt: machine.receipt,
              },
            })
              .then(() => {})
              .catch((e) => {
                console.log(e);
              });
          }, 5000);
          const data = [];
          separateItem.forEach((e) => {
            if (e.emailCode) {
              data.push({
                _id: e.product,
                promo: e.promo,
                name: e.product_name,
                upc: e.upc,
                email: input,
              });
              console.log('emailcode', e);
            }
          });
          if (data.length > 0) {
            request({
              method: 'post',
              url: EMAILCODE,
              data: {
                orderID: orderID,
                data: data,
              },
            })
              .then(() => {})
              .catch((e) => {
                console.log(e);
              });
          }
        }
      }
    }
  }, [readySend, receiptSend]);

  const setShowhide = (v) => {
    setShow(false);
    props.setShow(false);
  };

  const setShowshow = (v) => {
    setShow(true);
    props.setShow(true);
  };

  if (receipt !== '' && receipt !== undefined && receipt !== null && inputShow && !receiptSend) {
    return (
      <div className="email-main-container">
        <div
          style={{
            width: '650px',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 'auto',
          }}
          className="d-flex justify-content-center"
        >
          {error !== '' && <p className="email-error">{error}</p>}
          <input
            id="email-enter-input"
            type="email"
            placeholder="Email"
            value={input}
            onChange={onChangeInput}
            className="email-input"
            onBlur={setShowhide}
            onFocus={setShowshow}
            ref={keyboard}
          />
        </div>
        <div style={{ width: '650px', margin: 'auto', display: 'flex', marginTop: '20px' }}>
          <div
            style={{ display: 'inline' }}
            onClick={() => {
              setCheck(!isCheck);
            }}
          >
            {isCheck ? <CheckedBox width={34.5} /> : <UncheckedBox width={34.5} />}
          </div>
          <div className="checkboxtext">
            {t(
              'Send me discounts, special offers, new product alerts and marketing updates from TravelWifi.'
            )}
          </div>
        </div>
        <KeyBoard
          setReceiptSend={props.setReceiptSend}
          show={show}
          input={input}
          setInput={setInput}
          error={error}
          keyboard={keyboard}
          setShow={props.setShow}
          send={true}
          setError={setError}
        />
      </div>
    );
  } else return null;
}
